import { render, staticRenderFns } from "./BussinessChangePwd.vue?vue&type=template&id=31768841&"
import script from "./BussinessChangePwd.vue?vue&type=script&lang=js&"
export * from "./BussinessChangePwd.vue?vue&type=script&lang=js&"
import style0 from "./BussinessChangePwd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports